import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function DFArt() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-853">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-854">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-855">
          <p className="font-serif italic text-[#FF1493] text-lg mb-4" data-id="element-856">
            As Dr. Fiona Says…
          </p>

          <h2 className="text-[28px] lg:text-[44px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-857">
            FILLERS ARE AN ART
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-10" data-id="element-858"></div>

          {/* Pull Quote */}
          <div className="relative max-w-[700px] mx-auto mb-12" data-id="element-859">
            <div className="text-[#FF1493] text-[60px] font-serif leading-none select-none opacity-60 mb-2" data-id="element-860">
              &ldquo;
            </div>
            <p className="font-serif italic text-black text-lg lg:text-[22px] leading-[1.6]" data-id="element-861">
              Fillers are an art, so you need to make sure you find an artist
              who believes in listening to your goals and not just following a
              formula.
            </p>
          </div>

          <div className="space-y-6 text-[#333333] text-[17px] leading-[1.8] font-body" data-id="element-862">
            <p data-id="element-863">
              When done right, dermal fillers can accentuate good features and
              magnify your beauty. They can also correct volume deficits that
              may detract from your aesthetic appearance. Cosmetic concerns like
              sunken eyes, flat cheeks or nasolabial folds can be addressed
              beautifully with filler.
            </p>
            <p data-id="element-864">
              The correct dermal filler can naturally replace underlying volume
              loss for a more youthful, rested appearance. If you want to
              magnify your beauty into something even more phenomenal, it is
              essential that you find the right artist who you feel comfortable
              with and who has evidence of great work. Every artist should have
              masterpieces!
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}